module.exports = __webpack_public_path__ + "static/media/cancel.cafa0ce0.svg";